import { Routes, Route } from "react-router-dom";
import { Home } from "./pages/Home";
import { Dashboard } from "./pages/Home/Dashboard";
import { Audit } from "./pages/Home/Dashboard/Audit";
import { Basket } from "./pages/Home/Dashboard/Basket";
import { Documents as DashboardDocuments } from "./pages/Home/Dashboard/Documents";
import { Main } from "./pages/Home/Dashboard/Main";
import { Support } from "./pages/Home/Dashboard/Support";
import { Contact } from "./pages/Home/Dashboard/Support/Contact";
import { Instruction } from "./pages/Home/Dashboard/Support/Instruction";
import { More } from "./pages/Home/Dashboard/Support/More";
import { Products } from "./pages/Home/Products";
import { Complect } from "./pages/Home/Products/Parameters/Complect";
import { Edit } from "./pages/Home/Products/Parameters/Edit";
import { Group } from "./pages/Home/Products/Parameters/Group";
import { Party as ParametersParty } from "./pages/Home/Products/Parameters/Party";
import { Product } from "./pages/Home/Products/Parameters/Product";
import { Search } from "./pages/Home/Products/Parameters/Search";
import { Series } from "./pages/Home/Products/Parameters/Series";
import { Service } from "./pages/Home/Products/Parameters/Service";
import { Units as ParametersUnits } from "./pages/Home/Products/Parameters/Units";
import { Kit } from "./pages/Home/Products/Parameters/Kit";
import { Modification } from "./pages/Home/Products/Parameters/Modification";
import { Parameters } from "./pages/Home/Products/Parameters";
import { PriceTypes as ParametersPriceTypes } from "./pages/Home/Products/Parameters/PriceTypes";
import { Archive } from "./pages/Home/Products/Parameters/Archive";
import { Enter } from "./pages/Home/Products/Enter";
import { Loss } from "./pages/Home/Products/Loss";
import { Move } from "./pages/Home/Products/Move";
import { Inventory } from "./pages/Home/Products/Inventory";
import { Supplies } from "./pages/Home/Supplies";
import { Supply } from "./pages/Home/Supplies/Supply";
import { Expense } from "./pages/Home/Supplies/Expense";
import { Order as SuppliesOrder } from "./pages/Home/Supplies/Order";
import { Return as SuppliesReturn } from "./pages/Home/Supplies/Return";
import { PrepareOrder } from "./pages/Home/Supplies/PrepareOrder";
import { Demands } from "./pages/Home/Demands";
import { Demand } from "./pages/Home/Demands/Demand";
import { Return as DemandsReturn } from "./pages/Home/Demands/Return";
import { Order as DemandsOrder } from "./pages/Home/Demands/Order";
import { Comission } from "./pages/Home/Demands/Comission";
import { Customers } from "./pages/Home/Customers";
import { Customer as CustomersCustomer } from "./pages/Home/Customers/Customer";
import { Discount as CustomersDiscount } from "./pages/Home/Customers/Discount";
import { PriceTypes as CustomersPriceTypes } from "./pages/Home/Customers/PriceTypes";
import { Finance } from "./pages/Home/Finance";
import { Payments } from "./pages/Home/Finance/Payments";
import { PaymentIn } from "./pages/Home/Finance/Payments/PaymentIn";
import { PaymentOut } from "./pages/Home/Finance/Payments/PaymentOut";
import { SpendItem } from "./pages/Home/Finance/Payments/SpendItem";
import { Debts as FinanceDebts } from "./pages/Home/Finance/Debts";
import { Expeditors } from "./pages/Home/Expeditors";
import { HandoverTo } from "./pages/Home/Expeditors/HandoverTo";
import { HandoverFrom } from "./pages/Home/Expeditors/HandoverFrom";
import { MoneyTransfer } from "./pages/Home/Expeditors/MoneyTransfer";
import { Expeditor } from "./pages/Home/Expeditors/Expeditor";
import { Cash } from "./pages/Home/Cash";
import { Program } from "./pages/Home/Cash/Program";
import { Login } from "./pages/Home/Cash/Login";
import { Sale } from "./pages/Home/Cash/Sale";
import { Return as CashReturn } from "./pages/Home/Cash/Return";
import { Turn } from "./pages/Home/Cash/Turn";
import { Payments as CashPayments } from "./pages/Home/Cash/Payments";
import { HandPanel } from "./pages/Home/Cash/HandPanel";
import { Settings as RetialSettings } from "./pages/Home/Cash/Settings";
import { Admin } from "./pages/Home/Cash/Settings/Admin";
import { Check } from "./pages/Home/Cash/Settings/Check";
import { Fiscal } from "./pages/Home/Cash/Settings/Fiscal";
import { Product as SettingsProduct } from "./pages/Home/Cash/Settings/Product";
import { CustomerGroups } from "./pages/Home/Cash/Settings/CustomerGroups";
import { Security } from "./pages/Home/Cash/Settings/Security";
import { RightPanel } from "./pages/Home/Cash/RightPanel";
import { Customer as CashCustomer } from "./pages/Home/Cash/Customer";
import { Discount as CashDiscount } from "./pages/Home/Cash/Discount";
import { PaymentTypes } from "./pages/Home/Cash/PaymentTypes";
import { Queue } from "./pages/Home/Cash/Queue";
import { Credit } from "./pages/Home/Cash/Credit";
import { Sale as CreditSale } from "./pages/Home/Cash/Credit/Sale";
import { Return as CreditReturn } from "./pages/Home/Cash/Credit/Return";
import { Party as CashParty } from "./pages/Home/Cash/Party";
import { Units as CashUnits } from "./pages/Home/Cash/Units";
import { Reports } from "./pages/Home/Reports";
import { Profit } from "./pages/Home/Reports/Profit";
import { ProfitLoss } from "./pages/Home/Reports/ProfitLoss";
import { Turnover } from "./pages/Home/Reports/Turnover";
import { Debts as ReportsDebts } from "./pages/Home/Reports/Debts";
import { Balance } from "./pages/Home/Reports/Balance";
import { StockBalance } from "./pages/Home/Reports/StockBalance";
import { Settings } from "./pages/Home/Settings";
import { Profile } from "./pages/Home/Settings/Profile";
import { Rates } from "./pages/Home/Settings/Rates";
import { Payment } from "./pages/Home/Settings/Payment";
import { MilliOn } from "./pages/Home/Settings/Payment/MilliOn";
import { EManat } from "./pages/Home/Settings/Payment/EManat";
import { InProgram } from "./pages/Home/Settings/Payment/InProgram";
import { History } from "./pages/Home/Settings/Payment/History";
import { Control } from "./pages/Home/Settings/Control";
import { Stocks } from "./pages/Home/Settings/Stocks";
import { Owners } from "./pages/Home/Settings/Owners";
import { Departments } from "./pages/Home/Settings/Departments";
import { Templates } from "./pages/Home/Settings/Templates";
import { SpendItems } from "./pages/Home/Settings/SpendItems";
import { Common } from "./pages/Home/Common";
import { Print } from "./pages/Home/Common/Print";
import { Save } from "./pages/Home/Common/Save";
import { Close } from "./pages/Home/Common/Close";
import { Excel } from "./pages/Home/Common/Excel";
import { CloseAlert } from "./pages/Home/Common/CloseAlert";
import { Shorts } from "./pages/Home/Common/Shorts";
import { FastSearch } from "./pages/Home/Common/FastSearch";
import { Filter } from "./pages/Home/Common/Filter";
import { StockQuantity } from "./pages/Home/Common/StockQuantity";
import { Owner } from "./pages/Home/Common/Owner";
import { Department } from "./pages/Home/Common/Department";
import { Status } from "./pages/Home/Common/Status";
import { Related } from "./pages/Home/Common/Related";
import { Discount as CommonDiscount } from "./pages/Home/Common/Discount";
import { Terms } from "./pages/Home/Common/Terms";
import { Modifications } from "./pages/Home/Common/Modifications";

const Router = () => {
    return (
        <Routes>
            <Route path={"/"} element={<Home />} />

            <Route path={"/dashboard"} element={<Dashboard />} />
            <Route path={"/dashboard/main"} element={<Main />} />
            <Route path={"/dashboard/documents"} element={<DashboardDocuments />} />
            <Route path={"/dashboard/basket"} element={<Basket />} />
            <Route path={"/dashboard/audit"} element={<Audit />} />
            <Route path={"/dashboard/support"} element={<Support />} />
            <Route path={"/dashboard/support/more"} element={<More />} />
            <Route path={"/dashboard/support/instruction"} element={<Instruction />} />
            <Route path={"/dashboard/support/contact"} element={<Contact />} />

            <Route path={"/products"} element={<Products />} />
            <Route path={"/products/parameters"} element={<Parameters />} />
            <Route path={"/products/parameters/product"} element={<Product />} />
            <Route path={"/products/parameters/service"} element={<Service />} />
            <Route path={"/products/parameters/group"} element={<Group />} />
            <Route path={"/products/parameters/complect"} element={<Complect />} />
            <Route path={"/products/parameters/party"} element={<ParametersParty />} />
            <Route path={"/products/parameters/series"} element={<Series />} />
            <Route path={"/products/parameters/edit"} element={<Edit />} />
            <Route path={"/products/parameters/search"} element={<Search />} />
            <Route path={"/products/parameters/units"} element={<ParametersUnits />} />
            <Route path={"/products/parameters/kit"} element={<Kit />} />
            <Route path={"/products/parameters/modification"} element={<Modification />} />
            <Route path={"/products/parameters/pricetypes"} element={<ParametersPriceTypes />} />
            <Route path={"/products/parameters/archive"} element={<Archive />} />
            <Route path={"/products/enter"} element={<Enter />} />
            <Route path={"/products/loss"} element={<Loss />} />
            <Route path={"/products/move"} element={<Move />} />
            <Route path={"/products/inventory"} element={<Inventory />} />

            <Route path={"/supplies"} element={<Supplies />} />
            <Route path={"/supplies/supply"} element={<Supply />} />
            <Route path={"/supplies/expense"} element={<Expense />} />
            <Route path={"/supplies/return"} element={<SuppliesReturn />} />
            <Route path={"/supplies/order"} element={<SuppliesOrder />} />
            <Route path={"/supplies/prepareorder"} element={<PrepareOrder />} />

            <Route path={"/demands"} element={<Demands />} />
            <Route path={"/demands/demand"} element={<Demand />} />
            <Route path={"/demands/return"} element={<DemandsReturn />} />
            <Route path={"/demands/order"} element={<DemandsOrder />} />
            <Route path={"/demands/comission"} element={<Comission />} />

            <Route path={"/customers"} element={<Customers />} />
            <Route path={"/customers/customer"} element={<CustomersCustomer />} />
            <Route path={"/customers/discount"} element={<CustomersDiscount />} />
            <Route path={"/customers/pricetypes"} element={<CustomersPriceTypes />} />

            <Route path={"/finance"} element={<Finance />} />
            <Route path={"/finance/payments"} element={<Payments />} />
            <Route path={"/finance/payments/paymentin"} element={<PaymentIn />} />
            <Route path={"/finance/payments/paymentout"} element={<PaymentOut />} />
            <Route path={"/finance/payments/spenditem"} element={<SpendItem />} />
            <Route path={"/finance/debts"} element={<FinanceDebts />} />

            <Route path={"/expeditors"} element={<Expeditors />} />
            <Route path={"/expeditors/handoverto"} element={<HandoverTo />} />
            <Route path={"/expeditors/handoverfrom"} element={<HandoverFrom />} />
            <Route path={"/expeditors/moneytransfer"} element={<MoneyTransfer />} />
            <Route path={"/expeditors/expeditor"} element={<Expeditor />} />

            <Route path={"/cash"} element={<Cash />} />
            <Route path={"/cash/program"} element={<Program />} />
            <Route path={"/cash/login"} element={<Login />} />
            <Route path={"/cash/sale"} element={<Sale />} />
            <Route path={"/cash/return"} element={<CashReturn />} />
            <Route path={"/cash/turn"} element={<Turn />} />
            <Route path={"/cash/payments"} element={<CashPayments />} />
            <Route path={"/cash/handpanel"} element={<HandPanel />} />
            <Route path={"/cash/settings"} element={<RetialSettings />} />
            <Route path={"/cash/settings/admin"} element={<Admin />} />
            <Route path={"/cash/settings/check"} element={<Check />} />
            <Route path={"/cash/settings/fiscal"} element={<Fiscal />} />
            <Route path={"/cash/settings/product"} element={<SettingsProduct />} />
            <Route path={"/cash/settings/customergroups"} element={<CustomerGroups />} />
            <Route path={"/cash/settings/security"} element={<Security />} />
            <Route path={"/cash/rightpanel"} element={<RightPanel />} />
            <Route path={"/cash/customer"} element={<CashCustomer />} />
            <Route path={"/cash/discount"} element={<CashDiscount />} />
            <Route path={"/cash/paymenttypes"} element={<PaymentTypes />} />
            <Route path={"/cash/queue"} element={<Queue />} />
            <Route path={"/cash/credit"} element={<Credit />} />
            <Route path={"/cash/credit/sale"} element={<CreditSale />} />
            <Route path={"/cash/credit/return"} element={<CreditReturn />} />
            <Route path={"/cash/party"} element={<CashParty />} />
            <Route path={"/cash/units"} element={<CashUnits />} />

            <Route path={"/reports"} element={<Reports />} />
            <Route path={"/reports/profit"} element={<Profit />} />
            <Route path={"/reports/profitloss"} element={<ProfitLoss />} />
            <Route path={"/reports/turnover"} element={<Turnover />} />
            <Route path={"/reports/debts"} element={<ReportsDebts />} />
            <Route path={"/reports/balance"} element={<Balance />} />
            <Route path={"/reports/stockbalance"} element={<StockBalance />} />

            <Route path={"/settings"} element={<Settings />} />
            <Route path={"/settings/profile"} element={<Profile />} />
            <Route path={"/settings/rates"} element={<Rates />} />
            <Route path={"/settings/payment"} element={<Payment />} />
            <Route path={"/settings/payment/million"} element={<MilliOn />} />
            <Route path={"/settings/payment/emanat"} element={<EManat />} />
            <Route path={"/settings/payment/inprogram"} element={<InProgram />} />
            <Route path={"/settings/payment/history"} element={<History />} />
            <Route path={"/settings/control"} element={<Control />} />
            <Route path={"/settings/stocks"} element={<Stocks />} />
            <Route path={"/settings/owners"} element={<Owners />} />
            <Route path={"/settings/departments"} element={<Departments />} />
            <Route path={"/settings/templates"} element={<Templates />} />
            <Route path={"/settings/spenditems"} element={<SpendItems />} />

            <Route path={"/common"} element={<Common />} />
            <Route path={"/common/print"} element={<Print />} />
            <Route path={"/common/save"} element={<Save />} />
            <Route path={"/common/close"} element={<Close />} />
            <Route path={"/common/excel"} element={<Excel />} />
            <Route path={"/common/closealert"} element={<CloseAlert />} />
            <Route path={"/common/shorts"} element={<Shorts />} />
            <Route path={"/common/fastsearch"} element={<FastSearch />} />
            <Route path={"/common/filter"} element={<Filter />} />
            <Route path={"/common/stockquantity"} element={<StockQuantity />} />
            <Route path={"/common/owner"} element={<Owner />} />
            <Route path={"/common/department"} element={<Department />} />
            <Route path={"/common/status"} element={<Status />} />
            <Route path={"/common/related"} element={<Related />} />
            <Route path={"/common/discount"} element={<CommonDiscount />} />
            <Route path={"/common/modifications"} element={<Modifications />} />
            <Route path={"/common/terms"} element={<Terms />} />
        </Routes>
    );
};

export default Router;
